'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getButtons = undefined;

var _merge2 = require('ramda/src/merge');

var _merge3 = _interopRequireDefault(_merge2);

var _omit2 = require('ramda/src/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _assoc2 = require('ramda/src/assoc');

var _assoc3 = _interopRequireDefault(_assoc2);

var _path2 = require('ramda/src/path');

var _path3 = _interopRequireDefault(_path2);

var _forEach2 = require('ramda/src/forEach');

var _forEach3 = _interopRequireDefault(_forEach2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = ['prev', 'next', 'save', 'send'];
var defaultVisible = {
    prev: true,
    next: true,
    send: true,
    save: false
};

var getDefaultButton = function getDefaultButton(text) {
    return {
        visible: defaultVisible[text],
        text: text
    };
};

var getButtons = exports.getButtons = function getButtons() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rus';

    var buttons = {};

    (0, _forEach3.default)(function (type) {
        var defaultBtn = getDefaultButton(type);
        var btn = options[type] || {};
        btn = (0, _path3.default)(['text', language], btn) ? (0, _assoc3.default)('text', btn.text[language], btn) : (0, _omit3.default)(['text'], btn);

        buttons[type] = (0, _merge3.default)(defaultBtn, btn);
    }, types);

    return _extends({}, buttons, {
        lang: (0, _merge3.default)({
            visible: false,
            text: {
                rus: 'RU',
                enu: 'EN'
            }
        }, options.lang || {})
    });
};